import styles from "./style.module.scss";

type FormulaScopeChipProps = {
    label: string;
    variant: "default" | "format";
};

const FormulaScopeChip = ({ label, variant }: FormulaScopeChipProps) => {
    return <span className={`${styles.chip} ${styles[variant]}`}>{label}</span>;
};

export default FormulaScopeChip;
